import {
    PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID,
    RESET_PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID,
} from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface PutIncomeAttributeState extends BaseAsyncReducerState {
    snapshotId: number,
}

// Define an initial state value
const initialState: PutIncomeAttributeState = {
    success: false,
    message: "",
    loading: false,
    error: false,
    data: [],
    snapshotId: 0,
}

function putIncomeAttributesReducer(state = initialState, action: AppAction | LocalAction) {
    if (action.type === RESET_PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID) {
        return { ...initialState };
    } else {
        return defaultAsyncReducer(state, action as AppAction, PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID);
    }
}

export default putIncomeAttributesReducer;